import styled from 'styled-components'
import { get } from '@utils'

export const Hr = styled.hr`
  border: none;
  border-top: 2px dashed ${get('colors.gray')};
  margin: 55px 0 50px 0;
  height: 1px;
`
